import React from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import {
  ProjectStakeholderListContext,
  ProjectStakeholderListInitialState,
} from "./";

export const ProjectStakeholderListStateProvider = ({ children }: any) => {
  const [pageState, setPageState] = useState(
    ProjectStakeholderListInitialState,
  );
  const context = {
    pageState: pageState,
    setPageState: setPageState,
  };
  return (
    <ProjectStakeholderListContext.Provider value={context}>
      {children}
    </ProjectStakeholderListContext.Provider>
  );
};
